import React, { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import Home from './components/Home';
import './App.css'

import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutPage = lazy(() => import('./components/AboutPage'));
const ContactPage = lazy(() => import('./components/ContactPage'));
const ServicePage = lazy(() => import('./components/ServicePage'));
const WorkPage = lazy(() => import('./components/WorkPage'));
const BlogPage = lazy(() => import('./components/BlogPage'));
const NoPage = lazy(() => import('./components/NoPage'));

const LoadingFallback = () => (
  <div className="min-h-screen bg-primary-bg flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 50,
      duration: 600,
      easing: 'ease-out-cubic',
    });
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={
            <Suspense fallback={<LoadingFallback />}>
              <AboutPage />
            </Suspense>
          } />
          <Route path="services" element={
            <Suspense fallback={<LoadingFallback />}>
              <ServicePage />
            </Suspense>
          } />
          <Route path="projects" element={
            <Suspense fallback={<LoadingFallback />}>
              <WorkPage />
            </Suspense>
          } />
          <Route path="contact" element={
            <Suspense fallback={<LoadingFallback />}>
              <ContactPage />
            </Suspense>
          } />
          <Route path="blogs" element={
            <Suspense fallback={<LoadingFallback />}>
              <BlogPage />
            </Suspense>
          } />
          <Route path="*" element={
            <Suspense fallback={<LoadingFallback />}>
              <NoPage />
            </Suspense>
          } />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
